module.exports = __webpack_public_path__ + "static/img/zan-down-1.53ba6844.svg";